import { Component, OnInit, Input, ViewChild } from '@angular/core';

import { ConfirmationService, MenuItem } from 'primeng/api';
import { MessageService } from 'primeng/api';

// Export
import * as FileSaver from 'file-saver';
import { ExportService } from 'src/app/shared/services/export.service';

// Model
import { Table } from 'primeng/table';
import { ProductTypeCrudService } from 'src/app/shared/services/product-type-crud.service';
import { ProductType } from 'src/app/shared/interfaces/product-type';
import { Unit } from 'src/app/shared/interfaces/unit';
import { UnitCrudService } from 'src/app/shared/services/unit-crud.service';
import { ContentType } from 'src/app/shared/interfaces/content-type';
import { PackagingType } from 'src/app/shared/interfaces/packaging-type';
import { ContentTypeCrudService } from 'src/app/shared/services/content-type-crud.service';
import { PackagingTypeCrudService } from 'src/app/shared/services/packaging-type-crud.service';

@Component({
  selector: 'app-product-types',
  templateUrl: './product-types.component.html',
  styleUrls: ['./product-types.component.scss']
})
export class ProductTypesComponent implements OnInit {

  productTypes: ProductType[];
  productType: ProductType;
  selectedProductTypes: ProductType[] = [];

  productTypeDialog: boolean = false;

  submitted: boolean = false;

  units: Unit[] = [];
  contentTypes: ContentType[] = [];
  packagingTypes: PackagingType[] = [];

  minActivityValues: number[] = [0, 1000];
  maxActivityValues: number[] = [0, 1000];

  contentTypeMap = new Map<string, ContentType>();
  packagingTypeMap = new Map<string, PackagingType>();

  dialogSelectContentKey : string = "";
  dialogSelectPackagingKey : string = "";

  // column management
  cols: any[] = [];
  _selectedColumns: any[] = [];

  // export
  @ViewChild('dt', {static: true}) dt : any;
  exportColumns: any[] = [];

  // ui beadcrumb
  breadcrumbs: MenuItem[];
  homeBreadcrumb: MenuItem = {} as MenuItem;

  hideWhenNoPallet: boolean = false;
  noData: boolean = false;
  preLoader: boolean = true;

  constructor(
   // private api: APIService,
    private productTypeService : ProductTypeCrudService,
    // private unitService : UnitCrudService,
    private contentTypeService : ContentTypeCrudService,
    private packagingTypeService : PackagingTypeCrudService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private exportService: ExportService
  ) { 
    // ui breadcrumbs
    this.breadcrumbs = [
      {label: 'Settings'},
      {label: 'Product types'}
    ];

    this.productTypes = [];
    this.productType = { } as ProductType ;
    //this.getAllRecords();
  }

  ngOnInit(): void {
    
    this.dataState();
    let s = this.productTypeService.GetProductTypesList(); 
    s.snapshotChanges().subscribe(data => {
      this.productTypes = [];
      data.forEach(item => {
        let jsonItem : { '$key': string | null } = item.payload.toJSON() as { '$key': string | null } ; 
        if (jsonItem) {
          if (jsonItem) {
            jsonItem['$key'] = item.key;
          }
          this.productTypes.push(jsonItem as ProductType);
        }
      });

    });

    // let u = this.unitService.GetUnitsList(); 
    // u.snapshotChanges().subscribe(data => {
    //   this.units = [];
    //   data.forEach(item => {
    //     let jsonItem : { '$key': string | null } = item.payload.toJSON() as { '$key': string | null } ; 
    //     if (jsonItem) {
    //       if (jsonItem) {
    //         jsonItem['$key'] = item.key;
    //       }
    //       this.units.push(jsonItem as unknown as Unit);
    //     }
    //   })
    // });

    let ct = this.contentTypeService.GetContentTypesList(); 
    ct.snapshotChanges().subscribe(data => {
      this.contentTypes = [];
      data.forEach(item => {
        let jsonItem : { '$key': string | null } = item.payload.toJSON() as { '$key': string | null } ; 
        if (jsonItem) {
          if (jsonItem) {
            jsonItem['$key'] = item.key;
          }
          this.contentTypes.push(jsonItem as unknown as ContentType);
          const content = jsonItem as unknown as ContentType;
          this.contentTypeMap.set( content.$key , content );
        }
      });
      console.log( "contentTypes" ,this.contentTypes  );
      console.log( "contentTypeMap" ,this.contentTypeMap  );
    });

    let pt = this.packagingTypeService.GetPackagingTypesList(); 
    pt.snapshotChanges().subscribe(data => {
      this.packagingTypes = [];
      data.forEach(item => {
        let jsonItem : { '$key': string | null } = item.payload.toJSON() as { '$key': string | null } ; 
        if (jsonItem) {
          if (jsonItem) {
            jsonItem['$key'] = item.key;
          }
          this.packagingTypes.push(jsonItem as unknown as PackagingType);
          const packaging = jsonItem as unknown as PackagingType;
          this.packagingTypeMap.set( packaging.$key , packaging );
        }
      });
      console.log( "packagingTypes" ,this.packagingTypes  );
      console.log( "packagingTypeMap" ,this.packagingTypeMap  );
    });

    // column management
    this.cols = [
      { field: 'barcode', header: 'Barcode' },
      { field: 'name', header: 'Name' },
      { field: 'content', header: 'Content' },
      { field: 'container', header: 'Packaging' },
      { field: 'isEnabled', header: 'Enabled' },
      { field: 'actions', header: 'Actions' } 
    ];

    this._selectedColumns = this.cols;

    // Exports
    this.exportColumns = this.cols.map(col => ({title: col.header, dataKey: col.field}));
  }

  dataState() {     
    this.productTypeService.GetProductTypesList().valueChanges().subscribe(data => {
      this.preLoader = false;
      if(data.length <= 0){
        this.hideWhenNoPallet = false;
        this.noData = true;
      } else {
        this.hideWhenNoPallet = true;
        this.noData = false;
      }
    })
  }

  includesCol(val: string) : boolean{
    let c = this._selectedColumns.find(c => c.field === val);
    return c;
  }

  // Column management
  @Input() get selectedColumns(): any[] {
    // console.log('selected columns', this._selectedColumns);
    return this._selectedColumns;
  }
  set selectedColumns(val: any[]) {
    //restore original order
    // console.log('before selected columns', this._selectedColumns);
    // console.log('before cols', this._selectedColumns);
    this._selectedColumns = this.cols.filter(col => val.includes(col));
    // console.log('after selected columns', this._selectedColumns);
  }

  // Export management
  exportPdf() {
    import("jspdf").then(jsPDF => {
        import("jspdf-autotable").then(x => {
            const doc = new jsPDF.default('l','pt');
            // @ts-ignore
            doc.autoTable(this.exportColumns, this.ProductTypes);
            doc.save('content-types.pdf');
        })
    })
  }

  exportExcel() {
    import("xlsx").then(xlsx => {
        const worksheet = xlsx.utils.json_to_sheet(this.productTypes);
        const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, "content-types");
    });
  }

  exportDTCSV() {
    console.log('export csv');
    this.dt.exportCSV();
  }

  exportToCsv(): void {
    //this.exportService.exportToCsv(this.productTypes, 'ProductTypes', ['companyId', 'companyName', '$key', 'actions']);
    let exportCols : string[] = [];
    this.selectedColumns.forEach( sc => exportCols.push(sc.field));
    this.exportService.exportToCsv(this.selectedProductTypes, 'content-types', exportCols);
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }

  // CRUD management
  openNew() {
    this.productType = {} as ProductType;
    this.submitted = false;
    this.productTypeDialog = true;
    this.dialogSelectContentKey = "";
    this.dialogSelectPackagingKey = "";
  }

  deleteSelectedProductTypes() {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete the selected Packaging Types?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.productTypes = this.productTypes.filter(val => !this.selectedProductTypes.includes(val));
          this.productTypes.forEach( pallet => {
            this.productTypeService.DeleteProductType(pallet.$key);
          } );
          
          this.selectedProductTypes = [];
          this.messageService.add({severity:'success', summary: 'Successful', detail: 'Packaging types deleted', life: 3000});
      }
  });
  }

  editProductType(productType: ProductType) {
    this.productType = {...productType};
    this.productTypeDialog = true;
  }

  deleteProductType(productType: ProductType) {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete ' + productType.name + '?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.productTypes = this.productTypes.filter(val => val.$key !== productType.$key);
            this.productType = {} as ProductType;
            this.productTypeService.DeleteProductType(productType.$key);
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'Packaging Type Deleted', life: 3000});
        }
    });
  }

  hideDialog() {
    this.productTypeDialog = false;
    this.submitted = false;
  }

  saveProductType() {
    this.submitted = true;
    if (this.productType.$key) {
      this.productTypes[this.findIndexById(this.productType.$key)] = this.productType;                
      this.productTypeService.UpdateProductType(this.productType);
      this.messageService.add({severity:'success', summary: 'Successful', detail: 'Packaging Type Updated', life: 3000});
    } else {
      // this.pallet.id = this.createId();
      // this.pallet.image = 'product-placeholder.svg';

      console.log("key dialogSelectPackagingKey", this.dialogSelectPackagingKey);
      console.log("key full map", this.packagingTypeMap);

      if ( this.packagingTypeMap.has( this.dialogSelectPackagingKey ) ) {
        const packaging = this.packagingTypeMap.get( this.dialogSelectPackagingKey );
        if (packaging) {
          this.productType.container = packaging ;
          if (this.productType.container.$key) {
            delete this.productType.container.$key
            delete this.productType.container.isEnabled
          }
        } else {
          console.error("no content found in map with key", this.dialogSelectPackagingKey);
          console.error("no content found in map ", this.packagingTypeMap);
        }
      } else {
        console.error("packaging not found", this.dialogSelectPackagingKey)
      }

      console.log("key dialogSelectContentgKey", this.dialogSelectContentKey);
      console.log("key content full map", this.contentTypeMap);

      if ( this.contentTypeMap.has( this.dialogSelectContentKey ) ) {
        const content = this.contentTypeMap.get( this.dialogSelectContentKey );
        if (content) {
          this.productType.content = content;
          if (this.productType.content.$key) {
            delete this.productType.content.$key
            delete this.productType.content.isEnabled
          }
        } else {
          console.error("no content found in map ", this.contentTypeMap);
        }
      } else {
        console.error("content not found", this.dialogSelectContentKey);
      }
      
      
      // dialogSelectContentKey = "";
      //  = "";)

      console.log(this.productType);
      this.productTypeService.AddProductType(this.productType);
      this.messageService.add({severity:'success', summary: 'Successful', detail: 'Product Type Created', life: 3000});
      this.productTypes = [...this.productTypes];
    }
    this.productTypeDialog = false;
    this.productType = { } as ProductType;
  }

  findIndexById(id: string): number {
    let index = -1;
    for (let i = 0; i < this.productTypes.length; i++) {
        if (this.productTypes[i].$key === id) {
            index = i;
            break;
        }
    } 
    return index;
  }

  filter( dt : Table, event : {target: any} ) {
    dt.filterGlobal( (event.target as HTMLInputElement).value, 'contains')
  }

  completeProductType(productType : ProductType) {
    const productTypeTmp = {
      ...productType
    };
    console.log("SAVE", productTypeTmp);
    this.productTypeService.UpdateProductType(  productTypeTmp );
  }

  onChangePackaging(key: any) {
    console.log("key", key);
    console.log("key map",this.packagingTypeMap.get(key));
    this.dialogSelectContentKey = key;

  }

  onChangeContent(key: any) {
    console.log("key", key);
    console.log("key map",this.contentTypeMap.get(key));
    this.dialogSelectPackagingKey = key;

  }

}
